export enum SupervisorUserColumns {
  userName,
  avgTasks,
  tasksOnTime,
  rank,
  remove,
}
